import { Injectable } from '@angular/core';
import { TicketService } from './ticket.service';

@Injectable({ providedIn: 'root' })
export class TicketResolver {
  constructor(private ticketService: TicketService) {}

  resolve() {
    return this.ticketService.fetchTickets();
  }
}
